import React from 'react'
import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { buildColumns } from './reports.columns'

export default function ReportsGrid({
    rows,
    loading,
    onDelete,
    onNavigate,
    processRowUpdate,
    canDeleteReports
}) {
    const columns = buildColumns(onDelete, canDeleteReports)

    return (
        <Box sx={{ height: 720 }}>
            <DataGrid
                rows={rows}
                columns={columns}
                getRowId={(row) => row._id}
                loading={loading}
                // editMode="cell"
                disableRowSelectionOnClick
                processRowUpdate={processRowUpdate}
                onCellClick={(params, event) => {
                    // if (params.colDef.editable) {
                    //     event.stopPropagation()
                    //     return
                    // }
                    onNavigate(params.row)
                }}
                pageSizeOptions={[25, 50, 100, 200]}
                getRowClassName={(params) =>
                    params.row?.isUrgent ? 'row-overdue' : ''
                }
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'dueDateFmt', sort: 'asc' }]
                    }
                }}
                sx={{
                    border: 0,
                    '& .MuiTablePagination-toolbar': {
                        minHeight: 48,
                        alignItems: 'center'
                    },

                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                        margin: 0
                    },

                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 700
                    },

                    '& .row-overdue': {
                        backgroundColor: 'rgba(244, 67, 54, 0.08)'
                    },
                    '& .MuiDataGrid-cell:focus': {
                        outline: 'none'
                    },
                    '& .MuiDataGrid-cell:focus-within': {
                        outline: 'none'
                    },

                    /* Remove blue focus outline on column headers */
                    '& .MuiDataGrid-columnHeader:focus': {
                        outline: 'none'
                    },
                    '& .MuiDataGrid-columnHeader:focus-within': {
                        outline: 'none'
                    },
                }}
                slots={{ toolbar: true }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 300 }
                    }
                }}
            />
        </Box>
    )
}